import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=a2b3d6a2&scoped=true&"
import script from "./Snackbar.vue?vue&type=script&lang=js&"
export * from "./Snackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b3d6a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/felix/Google Drive/Travail/Clients/syl-vain/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VSnackbar})
